export default __webpack_public_path__ + "static/media/logo.f66ea2ea.png";